export var questions = [
  {
    mainQuestion: "Minha personalidade é mais...",
    subQuestions: [
      "de chefe e direta",
      "extrovertida e expressiva",
      "pacata e informal",
      "de bom senso e precisa"
    ]
  },
  {
    mainQuestion: "Eu prefiro um ambiente em que estou cercado por...",
    subQuestions: [
      "realização pessoal, recompensa e indicadores de alvos",
      'fotografias, cartas e minhas "coisas"',
      "lembranças e conforto",
      "ordem, funcionalidade e organização"
    ]
  },
  {
    mainQuestion: "Meu estilo pessoal tende a ser ...",
    subQuestions: [
      "orientado para resultados",
      "orientado para pessoas",
      "orientado para equipe/processos",
      "orientado para detalhes"
    ]
  },
  {
    mainQuestion: "Minha maneira de responder a outros é...",
    subQuestions: [
      "direta ao assunto",
      "amigável e prestativa",
      "equilibrada e controlada",
      "fria e objetiva"
    ]
  },
  {
    mainQuestion: "Quando ouço os outros, eu...",
    subQuestions: [
      "fico impaciente muitas vezes",
      "minha mente começa a divagar",
      "quero ouvir com atenção",
      "sou seletivo e focalizo os fatos."
    ]
  },
  {
    mainQuestion: "Eu gosto de falar com outros...",
    subQuestions: [
      "sobre minhas realizações",
      "sobre mim mesmo e outras pessoas",
      "sobre minha familia e amigos",
      "sobre coisas, informações ou organização"
    ]
  },
  {
    mainQuestion: "Nos relacionamentos, minha tendência é...",
    subQuestions: [
      "dirigir outros",
      "influenciar outros",
      "aceitar outros",
      "avaliar outros"
    ]
  },
  {
    mainQuestion: "Quando tomo decisões, eu tenho inclinação para...",
    subQuestions: [
      "ser rápido ou usar as reações impulsivas",
      "fazer o que eu sinto",
      "estudar a situação e ser cauteloso",
      "coletar informções e ser objetivo"
    ]
  },
  {
    mainQuestion: "Em relação ao uso do meu tempo, eu acho que...",
    subQuestions: [
      "estou sempre pressionado pelo tempo",
      "eu tendo a pensar no custo do tempo",
      "eu respeito o tempo, mas não sou facilmente pressionado",
      "eu valorizo e administro bem meu tempo"
    ]
  },
  {
    mainQuestion: "O ritmo com que eu vivo é...",
    subQuestions: ["veloz", "entusiástico", "equilibrado", "controlado"]
  },
  {
    mainQuestion: "Meu tom normal de voz é...",
    subQuestions: [
      "emotivo, direto e dinâmico",
      "emotivo e entusiasmado",
      "de baixa emoção e baixa excitação",
      "sem emoção e reservado"
    ]
  },
  {
    mainQuestion: "Meu gestos geralmente são...",
    subQuestions: [
      "fortes e rápidos",
      "abertos e amigáveis",
      "comedidos",
      "restritos e intencionais"
    ]
  },
  {
    mainQuestion: "Minha maneira preferida de vestir-me é...",
    subQuestions: ["formal", "casual", "conforme o lugar", "conservador(a)"]
  },
  {
    mainQuestion: "Minhas atitudes em geral podem ser descritas como...",
    subQuestions: [
      "autoritárias",
      "elegantes, simpáticas e extrovertida",
      "tolerantes ou abertas",
      "observadoras ou reservadas"
    ]
  },
  {
    mainQuestion: "Minhas conversas giram em torno de...",
    subQuestions: [
      'ir ao "X" da questão',
      "histórias sobre mim mesmo e outros",
      '"como fazer" e/ou relacionamentos',
      "fatos, informações e dados"
    ]
  }
];
